<div class="container-fluid">
  <div class="search-bar">
    <div class="row">
      <div class="col">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="row customWrapper">
      <div class="col-auto mr-auto" *ngIf="showFilter">
        <ng-container *ngIf="!serverPagination">
          <div class="row">
            <div class="col filter" style="width: 50rem">
              <mat-form-field style="margin-top: 10px" appearance="outline" floatLabel="always">
                <mat-label>Filtrer</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Tapez un mot, un nom, ..."
                  autocomplete="off" [(ngModel)]="tableNavigation.Keyword">
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-auto">
        <div class="row">
          <div class="col" *ngIf="showNewButton">
            <button type="button" class="btn btn-top" (click)="onNew()" tooltip="Créer">
              <span class="material-icons">
                add
              </span>
            </button>
          </div>
          <div class="col" *ngIf="showImportButton">
            <button type="button" class="btn btn-top" (click)="onImport()" tooltip="Importer">
              <span class="material-icons">backup</span>
            </button>
          </div>
          <div class="col" *ngIf="showSettingsButton">
            <button type="button" class="btn btn-top" (click)="onSettings()" tooltip="Configurer">
              <span class="material-icons">settings</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-end">
        <mat-icon mat-icon-button [matMenuTriggerFor]="menu" tooltip="Afficher / masquer des colonnes">settings
        </mat-icon>
        <mat-menu #menu="matMenu" (closed)="onDisplayColumnsMenuClosed()">
          <div class="mat-menu-item" *ngFor="let item of hideableColumns" (click)="$event.stopPropagation();">
            <mat-checkbox [(ngModel)]="item.IsVisible" [labelPosition]="'after'">{{item.DisplayName}}
            </mat-checkbox>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="card main-content">
    <div class="sticky-table-container table-content">
      <table mat-table [dataSource]="dataSource" matSort cdkDropList cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let colDef of columnsDefinition, index as i" matColumnDef="{{colDef.ColumnName}}"
          [sticky]="i==0">
          <ng-container *ngIf="colDef.Position==-2">
            <th mat-header-cell cdkDrag *matHeaderCellDef id="rowSelection">
              <mat-checkbox [(ngModel)]="isAllSelected" (change)="selectAll($event.checked)"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element" class="action-link"
              [ngClass]='{"selected-cell":selectedRows[element[keyColumn]]?.IsChecked === true}'>
              <div class="mat-select">
                <span>
                  <mat-checkbox [(ngModel)]="selectedRows[element[keyColumn]].IsChecked" (change)="select()">
                  </mat-checkbox>
                </span>
              </div>
            </td>
          </ng-container>
          <ng-container *ngIf="colDef.Position==-1">
            <th mat-header-cell cdkDrag *matHeaderCellDef id="actions">

            </th>
            <td mat-cell *matCellDef="let element" class="action-link"
              [ngClass]='{"selected-cell":selectedRows[element[keyColumn]]?.IsChecked === true}'>
              <div>
                <span *ngFor="let action of tableActions" [ngClass]="{'m-1' : action.Filter(element)}">
                  <a *ngIf="action.Filter(element) && !action.isReadOnly" (click)="action.Handler(element)" tooltip="{{action.Tooltip}}"><span
                      class="material-icons">
                      {{action.Icon}}
                    </span></a>
                </span>
              </div>
            </td>
          </ng-container>
          <ng-container *ngIf="colDef.Position > 0">
            <ng-container *ngIf="colDef.CanSort">
              <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header id="{{colDef.ColumnName}}"
                [hidden]="!colDef.IsVisible">
                {{colDef.DisplayName}}
              </th>
            </ng-container>
            <ng-container *ngIf="!colDef.CanSort">
              <th mat-header-cell cdkDrag *matHeaderCellDef id="{{colDef.ColumnName}}" [hidden]="!colDef.IsVisible"
                class="unsortable-header">
                {{colDef.DisplayName}}
              </th>
            </ng-container>
            <td mat-cell *matCellDef="let element" class="action-link" [hidden]="!colDef.IsVisible"
              [ngClass]='{"selected-cell":selectedRows[element[keyColumn]]?.IsChecked === true}'>
              <div [ngSwitch]="colDef.ColumnName">
                <div *ngIf="this.isActiveReadOnly">
                  <div *ngSwitchCase="'IsActive'">
                    <mat-slide-toggle [(ngModel)]="element['IsActive']" name="IsActive"
                      [disabled]="true"
                      (click)="false;">
                    </mat-slide-toggle>
                  </div>
                </div>

                <div *ngIf="!this.isActiveReadOnly">
                  <div *ngSwitchCase="'IsActive'">
                    <mat-slide-toggle [(ngModel)]="element['IsActive']" name="IsActive"
                      [disabled]="this.isActiveReadOnly || ((element['IsActive'] && !element['CanBeDisabled']) || (!element['IsActive'] && !element['CanBeEnabled']))"
                      (click)="onChangeStatus(element); false;">
                    </mat-slide-toggle>
                  </div>
                </div>

                <div *ngSwitchCase="'Indication'">
                  <span *ngFor="let indication of tableIndications">
                    <span *ngIf="indication.IsVisible(element)" tooltip="{{indication.Tooltip}}"
                      class="m-1 material-icons {{indication.CssClass}}">{{indication.Icon}}</span>
                  </span>
                </div>

                <div *ngSwitchDefault class="{{colDef.CssClass}}">
                  <ng-container *ngIf="!colDef.IsHtmlContent; else contentTemplate">
                    <span *ngIf="!colDef?.ToolTip">
                      {{ (extractData(element, colDef.ColumnName)) | dynamic : colDef?.Pipe?.ParamExtractor(element)
                      : colDef.Pipe }}
                    </span>
                    <span *ngIf="colDef?.ToolTip" tooltip="{{ (extractData(element, colDef.ColumnName)) | dynamic : colDef?.Pipe?.ParamExtractor(element)
                      : colDef.Pipe }}">
                      {{ (extractData(element, colDef.ColumnName)) | dynamic : colDef?.Pipe?.ParamExtractor(element)
                      : colDef.Pipe }}
                    </span>
                  </ng-container>
                  <ng-template #contentTemplate>
                    <div [innerHTML]="element[colDef.ColumnName]"></div>
                  </ng-template>
                </div>

              </div>
            </td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <div fxLayout="row" fxLayoutAlign="end">
      <mat-paginator [pageSize]="pageSize" [length]="length" [pageSizeOptions]="[5, 15, 20, 25, 30]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
  <ng-content select="[mass-actions]"></ng-content>
</div>
